import { Button } from "reactstrap";

import styles from "Pages/Setup/Connect/Onboarding.module.css";

interface Props {
    goTo: (view: string) => void;
}

export default function JdeConnect({ goTo }: Props) {
    return (
        <div className={styles.panel}>
            <div className={styles.phead}>
                <div className={`${styles.logo} ${styles.logoJde}`}>JD</div>
                <div>
                    <div className={styles.pheadName}>JDE</div>
                    <div className={styles.pheadSub}>
                        Oracle JD Edwards connector setup is in progress
                    </div>
                </div>
                <span className={`${styles.pill} ${styles.pillTodo}`}>
                    <span className={styles.dot} /> Coming soon
                </span>
            </div>

            <div className={styles.tabs}>
                <button className={`${styles.tab} ${styles.tabActive}`}>
                    Connect
                </button>
                <button className={styles.tab} onClick={() => goTo("secondarytest")}>
                    Test Connection
                </button>
            </div>

            <div className={styles.sec}>
                <h4>JDE onboarding placeholder</h4>
                <p className={styles.hint}>
                    Ramp + JDE support is now split into dedicated components,
                    but JDE connection details are still being finalized.
                </p>
                <p className={styles.hint} style={{ marginBottom: 0 }}>
                    This panel is intentionally a placeholder so JDE-specific
                    required fields and setup guidance can be added without
                    changing the Ramp + CMiC flow.
                </p>
            </div>

            <div className={styles.footbar}>
                <Button color="link" onClick={() => goTo("ramp")}>← Back to Ramp</Button>
                <span className={styles.saveState}>JDE setup steps coming soon.</span>
            </div>
        </div>
    );
}
